export * from './post-zeit.component';
export * from './post-zeit.component.module';